import { defer } from '@/components/utils/defer';

function detectHover() {
  // Detect hovering
  const menuItems = document.querySelectorAll('.Header__MainNav .HorizontalList__Item');
  const dropdowns = document.querySelectorAll('.TieredMenu__item');
  menuItems.forEach((el) => {
    el.addEventListener('mouseover', (event) => {
      let target = event.currentTarget as HTMLElement;
      if (target) {
        hideActiveMenu();

        // Show the overlay with the same data-handle
        let menuName = target.getAttribute('data-handle');
        let targetDropdown = document.querySelector(`.TieredMenu__item[data-handle="${menuName}"]`);
        if (targetDropdown) {
          targetDropdown.classList.add('active');
        }
        document.querySelector('.TieredMenu__dropdown-overlay')?.classList.add('active');
      }

      if (!el.classList.contains('has-overlay')) {
        hideActiveMenu();
      }
    });
  });

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('mouseleave', (event) => {
      hideActiveMenu();
    });

    // Hydrate close button
    const closeButton = dropdown.querySelector('.close');
    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        hideActiveMenu();
      });
    }
  });
}

function detectCatagoryHover() {
  const catagoryWrappers = document.querySelectorAll('.TieredMenu__catagory-wrapper');

  catagoryWrappers.forEach((wrapper) => {
    const topCatagory = wrapper.querySelectorAll('.TieredMenu__catagories');
    topCatagory.forEach((el) => {
      selectActiveCatagory(wrapper, el);
    });
  });
}

function selectActiveCatagory(wrapper: Element, el: Element) {
  const catagoryLinks = el.querySelectorAll('.TieredMenu__catagory');

  catagoryLinks.forEach((catagory) => {
    catagory.addEventListener('mouseover', (event) => {
      event.preventDefault();
      // Remove all active options
      el.querySelectorAll('.TieredMenu__catagory').forEach((catagory) => {
        catagory.classList.remove('active');
      });
      document.querySelectorAll('.TieredMenu__subcatagories').forEach((subcatagory) => {
        subcatagory.classList.remove('active');
      });

      // Activate hovered option
      const target = event.currentTarget as HTMLElement;
      const targetHandle = target.getAttribute('data-catagory-handle');
      target.classList.add('active');
      const subcatagory = wrapper.querySelector(
        `.TieredMenu__subcatagories[data-catagory-handle="${targetHandle}"]`,
      );
      if (subcatagory) {
        subcatagory.classList.add('active');
      }
    });
  });
}

function hideActiveMenu() {
  document.querySelector('.TieredMenu__item.active')?.classList.remove('active');
  document.querySelector('.TieredMenu__dropdown-overlay.active')?.classList.remove('active');
}

function hydrateMenu() {
  detectHover();
  detectCatagoryHover();
}

defer(hydrateMenu, '.HorizontalList__Item');
